// extracted by css-extract-rspack-plugin
export default {"row":"PullRequestRow-module__row__BAAlGz3"};